<template>
  <!-- eslint-disable -->
  <form
    class="newsletter-input"
    :class="{ 'inverse-theme': useInverseTheme }"
    :action="`//nimiq.us16.list-manage.com/subscribe/post?u=${MAILCHIMP_ID}&id=${audience}`"
    method="post"
    name="mc-embedded-subscribe-form"
    target="_blank"
    novalidate
    @submit="later($event)"
  >
    <input
      v-model="email"
      type="email"
      name="EMAIL"
      placeholder="Enter e-mail address..."
    />

    <!-- Hidden input for form bot detection that should not be filled in by users. -->
    <input
      class="hidden-input"
      type="text"
      :name="`b_${MAILCHIMP_ID}_${audience}`"
      tabindex="-1"
      value=""
      aria-hidden="true"
    />

    <button
      v-show="email && email.length > 0"
      class="nq-button-pill"
      type="submit"
      value="Subscribe"
      name="subscribe"
      :class="{
        'light-blue enabled': isEmailValid
      }"
      :disabled="!isEmailValid"
    >
      <span>join</span>
    </button>
  </form>
</template>

<script>
/* eslint-disable */
export const Themes = {
  NORMAL: 'normal',
  INVERSE: 'inverse'
}

export default {
  props: {
    audience: {
      type: String,
    },
    theme: {
      type: String,
      default: Themes.NORMAL,
      validator: val => Object.values(Themes).includes(val)
    }
  },
  data() {
    return {
      MAILCHIMP_ID: '2ea4eaf6edab73606137ddf65',

      email: null
    }
  },
  methods: {
    later(e) {
      setTimeout(() => {
        this.$emit('sent', e)
      }, 1000);
    }
  },
  computed: {
    isEmailValid() {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(this.email)
    },
    useInverseTheme() {
      return this.theme === Themes.INVERSE
    }
  }
}
</script>

<style scoped>
.newsletter-input {
  display: inline-block;
  position: relative;
}

.newsletter-input input {
  border: 2px solid rgba(31, 35, 72, 0.1);
  border-radius: 500px;
  height: 64px;
  padding: 0 24px;
  font-weight: normal;
  font-size: var(--large-text-size);
  line-height: 1;
  color: rgba(31, 35, 72, 1);
  background-color: transparent;
  font-family: inherit;
  min-width: 416px;
  outline: none;
  transition: border-color var(--attr-duration) linear,
    color var(--attr-duration) linear;
}

.newsletter-input input::placeholder {
  color: rgba(31, 35, 72, 0.5);
}

.newsletter-input input:hover {
  color: var(--nimiq-light-blue);
}

.newsletter-input input:focus {
  border-color: rgba(5, 130, 202, 0.5);
  color: var(--nimiq-light-blue);
}

.newsletter-input.inverse-theme input {
  border-color: rgba(255, 255, 255, 0.3);
  color: var(--nimiq-white);
}

.newsletter-input.inverse-theme input::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.newsletter-input.inverse-theme input:hover,
.newsletter-input.inverse-theme input:focus {
  border-color: rgba(255, 255, 255, 0.5);
}

.newsletter-input .hidden-input {
  display: none;
}

.newsletter-input .nq-button-pill {
  position: absolute;
  right: 16px;
  top: 16px;
  height: 32px;
  border-radius: 16px;
  line-height: 1;
  cursor: not-allowed;
}

.newsletter-input .nq-button-pill.enabled {
  cursor: pointer;
}

.newsletter-input .nq-button-pill:not(.enabled) {
  background: rgba(31, 35, 72, 0.07);
  color: rgba(31, 35, 72, 0.3);
}

.newsletter-input.inverse-theme .nq-button-pill:not(.enabled) {
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.4);
}

.newsletter-input .nq-button-pill::after {
  border: none;
}

.newsletter-input .nq-button-pill:not(.enabled)::after {
  opacity: 0;
}

.newsletter-input .nq-button-pill > span {
  z-index: 1;
}

@media (max-width: 1000px) {
  .newsletter-input input {
    min-width: 360px;
  }
}

@media (max-width: 850px) {
  .newsletter-input input {
    height: 54px;
    min-width: 330px;
  }

  .newsletter-input .nq-button-pill {
    top: 11px;
    right: 11px;
  }
}

@media (max-width: 550px) {
  .newsletter-input {
    display: block;
    width: 100%;
  }
  .newsletter-input input {
    width: 100%;
    min-width: 0;
  }
}
</style>
